import {
  REQUEST,
  RESPONSE,
  FILTER,
  SELECT_PARENT,
  INVALIDATE,
  SimpleListAction
} from './SimpleListActions';
import { INIT_REDUCER } from '../../shared/SharedActions';

export type filterRowsFunction = (rows: Array<any>, filter: any) => Array<any>;

const simpleFilter: filterRowsFunction = (rows, filter) => rows;

function getDataKey(this: {
  filter: any;
  parent: string;
  supportPaging: boolean;
  paging: any;
}) {
  const that = this;
  let dataKey = '';

  // Filter
  dataKey += JSON.stringify(that.filter);

  // Parent
  dataKey += '_' + that.parent;

  // Stránkování, pokud je povoleno
  if (that.supportPaging) {
    dataKey += '_' + that.paging.getDataKey();
  }

  // ---

  return dataKey;
}

const initialState = {
  sourceRows: [], // zdrojové řádky
  filteredRows: [], // filtrované řádky
  count: 0,
  rows: [], // vyfiltrované řádky a případně jinak upravené řádky = určené pro konkrétní zobrazení
  isFetching: false,
  fetched: false,
  filter: {},
  filterRows: simpleFilter,
  currentDataKey: '',
  getDataKey,
  reducer: list,
  parent: null
};

export interface StoreConfig {
  filterRows?: filterRowsFunction;
  filter?: any;
}

export default function list(
  state = initialState,
  action: SimpleListAction<any> = {} as any,
  config: StoreConfig = null as any
) {
  // Konfigurace
  if (config) {
    state = { ...state };

    if (config.filterRows) {
      // metoda pro filtr
      state.filterRows = config.filterRows;
    }
    if (config.filter) {
      // inicializační filtr
      state.filter = config.filter;
    }
  }

  switch (action.type) {
    case INIT_REDUCER:
      return {
        ...action.store
      };
    case REQUEST:
      return {
        ...state,
        isFetching: true,
        currentDataKey: action.dataKey
      };
    case SELECT_PARENT:
      return {
        ...state,
        parent: action.parent,
        fetched: false,
        isFetching: false,
        sourceRows: [],
        filteredRows: [],
        rows: [],
        count: 0
      };
    case INVALIDATE: {
      return {
        ...state,
        currentDataKey: initialState.currentDataKey
      };
    }
    case RESPONSE: {
      const sourceRows = action.rows;
      const filteredRows = state.filterRows(sourceRows!, state.filter);
      const rows = filteredRows;

      return {
        ...state,
        isFetching: false,
        fetched: true,
        sourceRows,
        filteredRows,
        rows,
        count: action.count
      };
    }
    case FILTER: {
      const filteredRows = state.filterRows(state.sourceRows, action.filter);
      const rows = filteredRows;

      return {
        ...state,
        filter: action.filter,
        filteredRows,
        rows
      };
    }
    default:
      return state;
  }
}
